import { WinDisplay } from "@lib/titan2-slingo/dist/game/view/abstract/display/WinDisplay";
import { MouseBlocker } from "@lib/titan2/dist/game/control/MouseBlocker";
import { MouseBlockerProperties } from "@lib/titan2/dist/game/control/properties/MouseBlockerProperties";
import { gsap } from "gsap";
import { TicketViewEvent } from "../../../controller/event/GameEvent";
import { SlingoEvent } from "@lib/titan2-slingo/dist/game/controller/event/SlingoEvent";
/**
 * GameWinDisplay.ts
 */
export class GameWinDisplay extends WinDisplay {
    create() {
        super.create();
        this.mouseBlocker = new MouseBlocker(new MouseBlockerProperties(0x000000, 0.6));
    }
    addEventListeners() {
        super.addEventListeners();
        this.unregisterGame(SlingoEvent.SLINGO_COMPLETE);
        this.registerGame(TicketViewEvent.SLINGO_TICKET_ANIMATION_COMPLETE, this.handleSlingo);
    }
    handleSlingoAnimationComplete() {
        this.dispatchGame(SlingoEvent.SLINGO_PAY_TABLE);
    }
    createGameOver() {
        super.createGameOver();
    }
    startSummary() {
        this.summary.play();
        this.addChildAt(this.mouseBlocker, 0);
        this.addChild(this.summary);
        gsap.fromTo(this.mouseBlocker, { pixi: { autoAlpha: 0 } }, { pixi: { autoAlpha: 1 }, duration: 0.4 });
        this.dispatchGame(SlingoEvent.GAME_SUMMARY);
    }
    startGameOver() {
        this.summary.play();
        this.addChildAt(this.mouseBlocker, 0);
        this.addChild(this.summary);
        gsap.fromTo(this.mouseBlocker, { pixi: { autoAlpha: 0 } }, { pixi: { autoAlpha: 1 }, duration: 0.4 });
        this.dispatchGame(SlingoEvent.GAME_SUMMARY);
    }
    handleGameComplete() {
        this.removeChild(this.mouseBlocker);
        super.handleGameComplete();
    }
    handleReelsComplete() {
        //noop
    }
}
//# sourceMappingURL=GameWinDisplay.js.map